var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"circles-to-rhombuses-spinner",style:(_vm.spinnertStyle)},_vm._l((_vm.circlesStyles),function(cs,index){return _c('div',{key:index,staticClass:"circle",style:(cs)})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }